var _excluded = ["onRemove", "placeholder", "allowClear", "onClear", "forwardRef", "className", "disabled", "loading", "data", "selectAll", "value", "onChange", "renderTitle", "renderNodeTitle", "selectLeafOnly"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { CloseOutlined, CloseCircleFilled, LoadingOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import { keyBy } from 'lodash';
import { All } from '../constants';
import MultiCascaderContainer from '../container';

var Tag = function Tag(props) {
  var onRemove = props.onRemove,
      item = props.item,
      _props$renderTitle = props.renderTitle,
      renderTitle = _props$renderTitle === void 0 ? function () {
    return undefined;
  } : _props$renderTitle;

  var handleRemove = function handleRemove(event) {
    event.stopPropagation();

    if (onRemove) {
      onRemove(item);
    }
  };

  var value = item.value || item;
  var title = renderTitle(value === All ? 'All' : value) || item.title || (String(item) === '[object Object]' ? '' : String(item));
  return /*#__PURE__*/React.createElement("span", {
    className: "ant-select-selection-item"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ant-select-selection-item-content"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "ant-select-selection-item-remove"
  }, /*#__PURE__*/React.createElement(CloseOutlined, {
    onClick: handleRemove
  })));
};

var Selector = function Selector(props) {
  var onRemove = props.onRemove,
      placeholder = props.placeholder,
      allowClear = props.allowClear,
      onClear = props.onClear,
      forwardRef = props.forwardRef,
      className = props.className,
      disabled = props.disabled,
      loading = props.loading,
      data = props.data,
      selectAll = props.selectAll,
      value = props.value,
      onChange = props.onChange,
      renderTitle = props.renderTitle,
      renderNodeTitle = props.renderNodeTitle,
      selectLeafOnly = props.selectLeafOnly,
      rest = _objectWithoutProperties(props, _excluded);

  var _MultiCascaderContain = MultiCascaderContainer.useContainer(),
      selectedItems = _MultiCascaderContain.selectedItems;

  var selectedItemsMap = keyBy(selectedItems, 'value');
  var handleClear = useCallback(function (event) {
    event.stopPropagation();

    if (onClear) {
      onClear();
    }
  }, [onClear]);
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classnames('biz-component-multi-cascader-select ant-select ant-tree-select ant-select-multiple', className, {
      'ant-select-disabled': disabled
    }),
    ref: forwardRef
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-selector ant-select-selector",
    style: {
      paddingRight: !disabled && allowClear ? '24px' : undefined
    }
  }, (value || []).length ? (value || []).map(function (item) {
    return /*#__PURE__*/React.createElement(Tag, {
      key: item,
      onRemove: onRemove,
      item: selectedItemsMap[item] || item,
      renderTitle: renderTitle
    });
  }) : /*#__PURE__*/React.createElement("span", {
    className: "ant-select-selection-placeholder"
  }, placeholder)), !disabled && allowClear ? /*#__PURE__*/React.createElement("span", {
    className: "ant-select-clear",
    onClick: handleClear
  }, /*#__PURE__*/React.createElement(CloseCircleFilled, null)) : null, loading ? /*#__PURE__*/React.createElement("span", {
    className: "biz-component-multi-cascader-select-loading",
    onClick: handleClear
  }, /*#__PURE__*/React.createElement(LoadingOutlined, null)) : null);
};

export default Selector;